import {Row, Col, Form} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {TFormSignature} from '../../signatureFormsTypes'
import {FormikErrors, FormikTouched} from 'formik'
import React from 'react'
import {RichTextEditor} from '../../../shared/RichTextEditor'
import {buildLocalizedPickers} from '../../signatureFormsConst'

interface SignatureFormNotificationsProps {
  values: TFormSignature
  errors: FormikErrors<TFormSignature>
  touched: FormikTouched<TFormSignature>
  handleChange: (field: string, value: string) => void
  handleBlur: (field: string) => void
}

export const SignatureFormNotifications: React.FC<SignatureFormNotificationsProps> = ({
  values,
  errors,
  handleChange,
  handleBlur,
}) => {
  const intl = useIntl()
  const pickers = buildLocalizedPickers(intl)

  return (
    <div className='form-notifications'>
      <Row>
        <Col sm={12}>
          <div className='kt-heading kt-heading--md custom-border-brand'>
            <FormattedMessage
              id='documents.signatureForms.notifications.heading'
              defaultMessage='Signature form notifications'
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={12} className='email-content'>
          <Form.Group>
            <Form.Label>
              <FormattedMessage
                id='documents.signatureForms.field.emailContent'
                defaultMessage='Email content'
              /> {errors.emailContent ? <small className='text-danger'>{errors.emailContent}</small> : null}
            </Form.Label>
            <RichTextEditor
              value={values.emailContent}
              placeholder={intl.formatMessage({
                id: 'documents.signatureForms.notifications.emailPlaceholder',
                defaultMessage: 'Enter email content',
              })}
              onChange={(e) => handleChange('emailContent', e)}
              btnCustomPicker={pickers}
            />
          </Form.Group>
        </Col>
        <Col md={12} className='sms-content'>
          <Form.Group>
            <Form.Label>
              <FormattedMessage
                id='documents.signatureForms.field.smsContent'
                defaultMessage='SMS content'
              /> {errors.smsContent ? <small className='text-danger'>{errors.smsContent}</small> : null}
            </Form.Label>
            <Form.Control
              value={values.smsContent}
              onChange={(e) => handleChange('smsContent', e.target.value)}
              onBlur={() => handleBlur('smsContent')}
              required
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  )
}
